import { Platform, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { APP_TOP_BAR_ROW_HEIGHT } from '../constants/app-top-bar-layout'
import { colors } from '../theme'
import { VocaliseLogo } from './VocaliseLogo'

/** SVG wordmark vs Text: bottom boxes align but typographic baselines differ (~2px in inspector). */
const SUBTITLE_BASELINE_OPTICAL_NUDGE_PX = 2

interface AppScreenTopBarProps {
  subtitle?: string
}

export function AppScreenTopBar({ subtitle }: AppScreenTopBarProps) {
  const insets = useSafeAreaInsets()

  return (
    <View
      style={{
        paddingTop: insets.top,
        backgroundColor: colors.backgroundPrimary,
      }}
    >
      <View
        className="justify-center px-4"
        style={{ height: APP_TOP_BAR_ROW_HEIGHT }}
      >
        <View className="flex-row items-end">
          <VocaliseLogo height={14} color={colors.ink} />
          {subtitle != null ? (
            <Text
              className="ml-2 font-medium text-ink"
              style={[
                {
                  fontSize: 14,
                  lineHeight: 14,
                  transform: [
                    { translateY: SUBTITLE_BASELINE_OPTICAL_NUDGE_PX },
                  ],
                },
                Platform.OS === 'android'
                  ? { includeFontPadding: false }
                  : null,
              ]}
            >
              {subtitle}
            </Text>
          ) : null}
        </View>
      </View>
    </View>
  )
}
